import script from "./HelloWorld.vue?vue&type=script&lang=ts&setup=true"
export * from "./HelloWorld.vue?vue&type=script&lang=ts&setup=true"

import "./HelloWorld.vue?vue&type=style&index=0&id=49a3ea9d&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49a3ea9d"]])

export default __exports__